"use client";

import React from "react";
import { createContext } from "react";

import { DeviatingOpeningHours } from "types/DeviatingOpeningHours";

export const DeviatingOpeningHoursContext = createContext<DeviatingOpeningHours[]>([]);

export default function DeviatingOpeningHoursContextProvider({
  value,
  children,
}: {
  value: DeviatingOpeningHours[];
  children: React.ReactNode;
}) {
  return (
    <DeviatingOpeningHoursContext.Provider value={value}>
      {children}
    </DeviatingOpeningHoursContext.Provider>
  );
}
